import React, {useEffect} from "react";
import {Redirect, Route, Switch, useHistory} from "react-router-dom";
import HomeApp from "./HomeApp";
import {WineApp} from "./WineApp";
import {ProductDetailsPage} from "./WineApp/ProductDetailsPage";
import {VineyardApp} from "./VineyardApp";
import {WineTrailApp} from "./WineTrailApp";
import {AboutUsApp} from "./AboutUsApp";
import {HowToBuyApp} from "./HowToBuyApp";
import {ContactApp} from "./ContactApp";
import {ErrorApp} from "./ErrorApp";
import {BundleDetailsPage} from "./WineApp/BundleDetailsPage";
import {WineTastingApp} from "./WineTastingApp";
import {AwardsApp} from "./AwardsApp";
import {VoucherApp} from "./VoucherApp";
import {EventsApp} from "./EventsApp";
import {EventPage} from "./EventsApp/EventPage";

const MainApp = () => {

    const history = useHistory();
    useEffect(() => {
        window.scroll(0,0);
    }, [history.location.pathname])

    return (
        <Switch>
            <Route path="/kontakt" component={ContactApp}/>
            <Route path="/o_nas" component={AboutUsApp}/>
            <Route path="/winnica" component={VineyardApp}/>
            <Route path="/szlakwinny" component={WineTrailApp}/>
            <Route path="/wina/nagrody" component={AwardsApp}/>
            <Route path="/wina/sprzedaz" component={HowToBuyApp}/>
            <Route path="/wina/degustacja" component={WineTastingApp}/>
            <Route path="/wina/karta_win/:id" component={ProductDetailsPage}/>
            <Route path="/wina/na_prezent/:id" component={BundleDetailsPage}/>
            <Route path="/wina/karta_win" component={WineApp}/>
            <Route path="/voucher" component={VoucherApp}/>
            <Route path="/wydarzenia/:eventId" component={EventPage}/>
            <Route path="/wydarzenia" component={EventsApp}/>
            <Route exact path="/" component={HomeApp}/>
            <Route path={"/404"} component={ErrorApp}/>
            <Redirect to={"/404"}/>
        </Switch>
    )
};

export default MainApp;